import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { formatterNumberDecimals } from 'helpers/mathDictionary';
//Mui
import {
    ButtonGroup,
    OutlinedInput,
    InputAdornment,
    TableCell,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Box,
    Typography,
    TextField,
    Link,
    ListSubheader,
} from "@mui/material"

//Icons
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
import { blue, red } from '@material-ui/core/colors';
import ReplayIcon from '@mui/icons-material/Replay';
import WarningIcon from '@material-ui/icons/Warning';

import { surveyStyles } from './styles';


//Component
import RegularButton from 'components/CustomButtons/Button';
import { ModalV2 } from 'components/Modal/ModalV2';
import { useToggle } from 'hooks/useToggle';

import { DoneSwitch, } from "./customSwitches";

//Redux
import { modifyItems, submitApproval, savePriceIndividual } from 'redux/actions/integrations/itemsRequestActions';
import { setSnackbar } from 'redux/actions/search/searchActions';

export const SelectStations = (props) => {
    const { stations, item, type, categories, allClasses } = props
    const { itemUpdate } = useSelector(({ itemsRequests }) => itemsRequests)
    const { id: idUser, rules } = useSelector(({ login }) => login);
    const dispatch = useDispatch()
    const classes = surveyStyles();
    const [description, setDescription] = useState(item.description);
    const [itemNumber, setItemNumber] = useState(item?.itemNumber);
    const [uom, setUom] = useState(item?.uom);
    const [inventoriable, setInventoriable] = useState(item?.inventoriable);
    const [classType, setClassType] = useState(item?.class?.idClass);
    const [category, setCategory] = useState(item?.category?.idCategory);
    const firstStation = Object.values(stations)[0]
    const [price, setPrice] = useState(firstStation?.individualPrice ? firstStation?.individualPrice : item?.price)
    const [station, setStation] = useState(firstStation)
    const [individualPrice, setIndividualPrice] = useState(firstStation?.individualPrice ? true : false)
    const [status, setStatus] = useState(firstStation?.status)
    const [typeResponse, setTypeResponse] = useState();
    const [notes, setNotes] = useState();
    const [notesError, setNotesError] = useState();
    const [isAllPending, setIsAllPending] = useState(true);
    const [open, setOpen] = useToggle();
    const [openNotes, setOpenNotes] = useToggle();
    const [openModify, setOpenModify] = useToggle();

    const handleChangeNotes = (e) => {
        setNotes(e.target.value)
    }

    const handleInputOnChange = (e) => {
        setStation(e.target.value)
        setStatus(e.target.value.status)
        if (e.target.value?.individualPrice) {
            setIndividualPrice(true)
            setPrice(e.target.value.individualPrice)
        } else {
            setIndividualPrice(false)
            setPrice(item?.price)
        }
    }

    const handleIndividual = () => {
        if (rules.includes("INTEGRATIONS-ANALYST") && status === 'PENDING') {
            setIndividualPrice(!individualPrice)
        }
    }

    const handleInputPrice = (e) => {
        setPrice(e.target.value)
    }

    const handleOpenModalModify = () => {
        if (itemNumber === null) {
            dispatch(setSnackbar("Favor de agregar un número de artículo"))
            return
        }
        setOpenModify()
    }

    const handleModify = async () => {
        if (type === "CREATE") {
            await dispatch(modifyItems({
                type: type,
                idItem: item.id,
                description: description,
                itemNumber: itemNumber,
                uom: uom,
                inventoriable: inventoriable,
                idClass: classType?.value ? classType?.value : classType,
                idCategory: category?.value ? category?.value : category,
                price: parseFloat(price),
            }));
            if (individualPrice) {
                let priceFloat = parseFloat(price)
                dispatch(savePriceIndividual({ price: priceFloat }, item.id, station?.idStation))
            }
        } else {
            if (individualPrice) {
                let priceFloat = parseFloat(price)
                dispatch(savePriceIndividual({ price: priceFloat }, item.id, station?.idStation))
            } else {
                dispatch(modifyItems({
                    type: type,
                    idItem: item.id,
                    price: parseFloat(price)
                }));
            }
        }
    }

    const handleResponse = (type) => {
        if (type === true && item?.itemNumber === null) {
            dispatch(setSnackbar("Favor de guardar un número de artículo"))
            return
        }
        setTypeResponse(type)
        setOpen()
    }

    const handleSubmit = async () => {
        if (!typeResponse && !notes) {
            setNotesError('Favor de llenar notas');
        } else {
            const data = {
                status: typeResponse ? "APPROVED" : "REJECTED",
                idStation: station.idStation,
                idUserAnalyst: idUser,
                comments: notes ? notes : null
            }
            dispatch(submitApproval(item.id, data))
            setOpen()
        }
    }

    const unitTypes = [
        {
            value: 'PZA',
            label: 'Pieza'
        },
        {
            value: 'LTR',
            label: 'Litros'
        },
        {
            value: 'KGM',
            label: 'Kilogramos'
        },
        {
            value: 'MTR',
            label: 'Metros'
        }
    ];

    const isInventoriable = [
        {
            value: 1,
            name: "Si"
        },
        {
            value: 0,
            name: "No"
        }
    ]

    useEffect(() => {
        Object.values(stations).map(value => {
            if (value.status !== "PENDING") {
                setIsAllPending(false)
                return
            }
        })
    }, [])
    useEffect(() => {
        if (Object.keys(itemUpdate).length !== 0 && itemUpdate?.idItem === item.id) {
            setDescription(itemUpdate?.description ? itemUpdate?.description : description);
            setItemNumber(itemUpdate?.itemNumber ? itemUpdate?.itemNumber : itemNumber);
            setUom(itemUpdate?.uom ? itemUpdate?.uom : uom);
            setInventoriable(itemUpdate?.inventoriable ? itemUpdate?.inventoriable : inventoriable);
            setCategory(itemUpdate?.category ? itemUpdate?.idCategory : category);
            setClassType(itemUpdate?.class ? itemUpdate?.idClass : classType);
            setPrice(itemUpdate?.price ? itemUpdate?.price : price);
        }
    }, [itemUpdate])

    return (
        <>
            {type === "CREATE" && status === 'PENDING' && isAllPending && rules.includes("INTEGRATIONS-ANALYST") ?
                <>
                    <TableCell align="left">
                        <FormControl>
                            <InputLabel htmlFor="outlined-adornment-amount">Descripción</InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-amount"
                                label="Descripción"
                                value={description}
                                type="text"
                                name="description"
                                variant="outlined"
                                onChange={e => setDescription(e.target.value)}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell align="left">
                        <FormControl>
                            <InputLabel htmlFor="outlined-adornment-amount">Número Artículo</InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-amount"
                                label="itemNumber"
                                value={itemNumber}
                                type="text"
                                name="itemNumber"
                                variant="outlined"
                                onChange={e => setItemNumber(e.target.value)}
                            />
                        </FormControl>
                    </TableCell>
                    <TableCell align="left">
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="demo-simple-select-outlined-label">Unidad</InputLabel>
                            <Select
                                name="uom"
                                value={uom}
                                onChange={e => setUom(e.target.value)}
                                label="Unidad"
                            >
                                {
                                    Object.values(unitTypes).map(unitType => <MenuItem value={unitType.value}>{unitType.label}</MenuItem>)
                                }
                            </Select>
                        </FormControl>
                    </TableCell>
                    <TableCell align="left">
                        <FormControl fullWidth variant="outlined">
                            <Select
                                name="inventoriable"
                                value={inventoriable}
                                onChange={e => setInventoriable(e.target.value)}
                                label="Inventariable"
                            >
                                {
                                    Object.values(isInventoriable).map(isInvent => <MenuItem value={isInvent.value}>{isInvent.name}</MenuItem>)
                                }
                            </Select>
                        </FormControl>
                    </TableCell>
                    <TableCell align="left">
                        <FormControl fullWidth variant="outlined">
                            <Select
                                name="classType"
                                value={classType}
                                onChange={e => setClassType(e.target.value)}
                                label="Clase"
                            >
                                {
                                    Object.values(allClasses).map(classesData => <MenuItem value={classesData.id}>{classesData.name}</MenuItem>)
                                }
                            </Select>
                        </FormControl>
                    </TableCell>
                    <TableCell align="left">
                        <FormControl>
                            <Select
                                name="category"
                                value={category}
                                onChange={e => setCategory(e.target.value)}
                                label="Categoría"
                            >
                                {
                                    Object.values(categories).map(categoryData => <MenuItem value={categoryData.id}>{categoryData.name}</MenuItem>)
                                }
                            </Select>
                        </FormControl>
                    </TableCell>
                </>
                : type === "CREATE" && status !== 'PENDING'
                    || (type === "CREATE" && !rules.includes("INTEGRATIONS-ANALYST"))
                    || (type === "CREATE" && !isAllPending) ?
                    <>
                        <TableCell align="left" >
                            {description}
                        </TableCell>
                        <TableCell align="left" >
                            {itemNumber}
                        </TableCell>
                        <TableCell align="left" >
                            {uom}
                        </TableCell>
                        <TableCell align="left" >
                            {inventoriable ? "Si" : "No"}
                        </TableCell>
                        <TableCell align="left" >
                            {item?.class?.className}
                        </TableCell>
                        <TableCell align="left" >
                            {item?.category?.categoryName}
                        </TableCell>
                    </>
                    :
                    <>
                        <TableCell align="left" >
                            {description}
                        </TableCell>
                        <TableCell align="left" >
                            {itemNumber}
                        </TableCell>
                        <TableCell align="left" >
                            $ {station?.oraclePrice}
                        </TableCell>
                    </>
            }
            <TableCell align="left" >
                {status === 'PENDING' && rules.includes("INTEGRATIONS-ANALYST") ?
                    <FormControl>
                        <InputLabel htmlFor="outlined-adornment-amount">Precio</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-amount"
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            label="Precio"
                            value={price}
                            type="text"
                            name="price"
                            variant="outlined"
                            onChange={handleInputPrice}
                            disabled={type === "CREATE" && !isAllPending && !individualPrice}
                        />
                    </FormControl>
                    : "$" + formatterNumberDecimals(price, 2)
                }
            </TableCell>
            <TableCell align="left" >
                <DoneSwitch
                    checked={individualPrice}
                    onClick={() => handleIndividual()}
                />
            </TableCell>
            <TableCell align="left"  >
                <FormControl fullWidth variant="outlined">
                    <InputLabel id="demo-simple-select-outlined-label">Planta</InputLabel>
                    <Select
                        name={"station"}
                        value={station}
                        onChange={e => handleInputOnChange(e)}
                        label="Planta"
                    >
                        {Object.values(stations).some(station => station?.status === 'PENDING') &&
                            <ListSubheader>Pendientes</ListSubheader>
                        }
                        {
                            Object.values(stations).map(station => station?.status === 'PENDING' &&
                                <MenuItem value={station}>{station.name}</MenuItem>
                            )
                        }
                        {Object.values(stations).some(station => station?.status !== 'PENDING') &&
                            <ListSubheader>Revisados</ListSubheader>
                        }
                        {
                            Object.values(stations).map(station => station?.status !== 'PENDING' &&
                                <MenuItem value={station}>{station.name}</MenuItem>
                            )
                        }
                    </Select>
                </FormControl>
            </TableCell>
            <TableCell align="right">
                {status === 'PENDING' && rules.includes("INTEGRATIONS-ANALYST") ?
                    <ButtonGroup style={{ float: 'right' }}>
                        <RegularButton
                            color="info"
                            round
                            justIcon
                            tooltip="Guardar sin Aprobar"
                            style={{
                                float: 'right'
                            }}
                            onClick={handleOpenModalModify}
                        >
                            <SaveIcon />
                        </RegularButton>
                        <RegularButton
                            color="success"
                            round
                            justIcon
                            tooltip="Aprobar"
                            style={{
                                float: 'right'
                            }}
                            onClick={() => handleResponse(true)}
                        >
                            <CheckCircleIcon />
                        </RegularButton>
                        <RegularButton
                            color="danger"
                            round
                            justIcon
                            tooltip="Rechazar"
                            style={{
                                float: 'right'
                            }}
                            onClick={() => handleResponse(false)}
                        >
                            <CancelIcon />
                        </RegularButton>
                    </ButtonGroup>
                    : status === 'PENDING' && <Box style={classes.text}>
                        <PendingIcon color="info" />
                        <Typography style={classes.heading}>Pendiente</Typography>
                    </Box>
                }
                {status === 'APPROVED' &&
                    <Box style={classes.text}>
                        <CheckCircleIcon style={classes.iconG} />
                        <Typography style={classes.heading}>Aprobado</Typography>
                    </Box>
                }
                {status === 'IN ORACLE' &&
                    <Box style={classes.text}>
                        <CheckCircleIcon style={classes.iconG} />
                        <Typography style={classes.heading}>En Oracle</Typography>
                    </Box>
                }
                {status === 'FAILED' && rules.includes("INTEGRATIONS-ANALYST") ?
                    <ButtonGroup style={{ float: 'right' }}>
                        <RegularButton
                            color="success"
                            round
                            justIcon
                            tooltip="Subir a Oracle"
                            style={{
                                float: 'right'
                            }}
                            onClick={() => handleResponse(true)}
                        >
                            <ReplayIcon />
                        </RegularButton>
                    </ButtonGroup>
                    : status === 'FAILED' &&
                    <Box style={classes.text}>
                        <WarningIcon style={classes.iconW} />
                        <Typography style={classes.heading}>Fallo al cargar</Typography>
                    </Box>
                }
                {status === "REJECTED" &&

                    <Box style={classes.text}>
                        <CancelIcon style={classes.iconB} />
                        <Link component="button" variant="body2" onClick={setOpenNotes}>
                            <Typography style={classes.heading}>Rechazado <br /> Ver motivo</Typography>
                        </Link>
                    </Box>

                }
            </TableCell>
            <ModalV2
                open={openNotes}
                onClose={setOpenNotes}
                title='Motivo del rechazo'

            >
                <Box style={classes.text}>
                    <h4>{station?.comments}</h4>
                </Box>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: 8, marginTop: 16 }}>
                    <RegularButton tooltip="cancelar" color="danger" onClick={setOpenNotes}>Cerrar</RegularButton>
                </div>
            </ModalV2>

            <ModalV2
                open={openModify}
                onClose={setOpenModify}
                title='Datos a Modificar'
                justConfirm
            >
                <Box style={classes.text}>
                    {type === "UPDATE" ? <h4>Precio en {station?.name}:<br /> Anterior: ${item.price} Actual: ${price} </h4> :
                        <>
                            <h4>Estación {station?.name}<br />
                                Descripción Anterior: {item.description} Actual: {description} <br />
                                Número de Artículo Anterior: {item.itemNumber} Actual: {itemNumber} <br />
                                Unidad de Medida Anterior: {item.uom} Actual: {uom} <br />
                                Inventariable Anterior: {item.inventoriable ? "Si" : "No"} Actual: {inventoriable ? "Si" : "No"} <br />
                                Clase Anterior: {item?.class?.className} Actual: {allClasses[classType].name} <br />
                                Categoría Anterior: {item.category?.categoryName} Actual: {categories[category].name} <br />
                                Precio Anterior: ${item.price} Actual: ${price}  </h4>
                        </>}
                </Box>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: 8, marginTop: 16 }}>
                    <RegularButton tooltip="cancelar" color="danger" onClick={setOpenModify}>Cerrar</RegularButton>
                    <RegularButton tooltip="Guardar" color='info' onClick={handleModify}>Guardar</RegularButton>
                </div>
            </ModalV2>
            <ModalV2
                open={open}
                title={typeResponse ? "¿Estas seguro de Aprobar?" : "¿Estas seguro de Rechazar?"}
                onClose={setOpen}
                justConfirm
            >
                <div style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    {!typeResponse ?
                        <>
                            <Typography variant="body1" component="p" style={{ color: blue[300], marginBottom: 20, }}>
                                Favor de agregar motivo de rechazo
                            </Typography>
                            <TextField
                                fullWidth
                                label="Notas"
                                name="notes"
                                value={notes}
                                onChange={handleChangeNotes}
                                variant="outlined"
                                autoFocus={true}
                                error={notesError}
                                helperText={notesError}
                                multiline
                                rows={4}
                            />
                        </> :
                        <Typography variant="body1" component="p" style={{ color: blue[300] }}>
                            Recuerde guardar antes Aprobar
                        </Typography>
                    }
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: 8, marginTop: 16 }}>
                        <RegularButton tooltip="cancelar" color="warning" onClick={setOpen}>Cancelar</RegularButton>
                        <RegularButton color={typeResponse ? 'success' : "danger"} onClick={handleSubmit}>{typeResponse ? "Aprobar" : "Rechazar"}</RegularButton>
                    </div>
                </div>
            </ModalV2>
        </>
    )
}